module.exports = __webpack_public_path__ + "e218d4a770cd00d108831c36f1bc4f07.fbx";